import "@fortawesome/fontawesome-free/css/all.min.css"

import { createGlobalStyle } from "styled-components"

const GlobalStyle = createGlobalStyle`
html,
  body {
    margin: 0;
    height: auto;
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    background-color: transparent;
    @media (max-width: 520px) {
      height: 100%;
    }
  }

  body {
    font-family: "Source Sans Pro", "Helvetica Neue", "simple-line-icons",
      Helvetica, Arial, sans-serif;
      padding: 10px;
      @media (max-width: 520px) {
      padding: 0px;
    }
  }

  body.fontLoaded {
    font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  }

  p,
  label,
  button {
    font-family: "Source Sans Pro", Georgia, Times, "Times New Roman", serif;
  }

  h {
    font-family: Merriweather, sans-serif;
  }

  a {
    cursor: pointer;
  }

  button[disabled],
  html input[disabled] {
    cursor: not-allowed;
  }
`

export default GlobalStyle
